import React from 'react';
import { pathOr } from 'ramda';

// tools
import renderHtmlContent from '../../../../helpers/renderHtmlContent';

const FormFieldLabel = ({ label, name, rules }) => {
    const isRequired = pathOr(false, ['required'], rules);
    return(
        label && <label htmlFor={name}>
            {renderHtmlContent(label)}
            {isRequired && <span>*</span> }
        </label>
    )
}

export default FormFieldLabel;